/**
 * Single source of truth for table names.
 */
export const TABLES = {
  USERS: 'users_1740126000000',
  ITEMS: 'items_1740126000000',
  LOGS: 'drop_logs_1740126000000',
  CHARACTERS: 'characters_1740130000000',
  PILOT_MASTERS: 'pilot_masters_1740250000000',
  COMMENTS: 'comments_1740280000000'
};